export default __webpack_public_path__ + "static/media/ic_bonaire.3c8dcffc.svg";